import { useQuery } from "react-query"
import { AdminMessage } from "../api/adminMessage"
import { hydraTransform } from "../shared/utils/hydraTransformer"



type UseAdminMessage = {
    enableQuery: boolean,
    userId: string,
    userDate: string
}

export const useAdminMessage = ({ enableQuery, userId, userDate }: UseAdminMessage) => {

    const messagesQuery = useQuery(['admin_messages'], () => AdminMessage.getUserMessages(userId, userDate), {
        enabled: enableQuery,
        refetchOnWindowFocus: true,
        refetchInterval: 60 * 60 * 1000 //Refetch each hour
    })



    return {
        messages: hydraTransform(messagesQuery.data?.data ?? []),
        isMessagesLoading: messagesQuery.isLoading
    }
}